import React, { useCallback } from 'react';

import { PERMISSIONS, ROUTES } from '@/common';
import { useHistory } from '@/modules/core';
import { Access } from '@/modules/core/components';
import { Employee } from '@/modules/employee';

const EmployeePage = () => {
  const history = useHistory();
  const goHome = useCallback(() => history.push(ROUTES.HOME), [history]);
  return (
    <Access
      accessRequirements={[
        {
          permission: PERMISSIONS.VIEW_PROFILE,
        },
      ]}
      accessDeniedAction={goHome}
    >
      <Employee />
    </Access>
  );
};

export default EmployeePage;
